import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { evolutionCurrentPeriod, productPagesKpiEndDate } from "../@signals"


export const rangeDatesPPKpi = [
    {
        label: 'Yesterday',
        value: () => { return [getPreviousDate({ days: 1 }, productPagesKpiEndDate.value), getPreviousDate({ days: 1 }, productPagesKpiEndDate.value)] },
        placement: 'left',
        onFocus: () => evolutionCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: 'Last 7 Days',
        value: () => { return [getPreviousDate({ days: 7 }, productPagesKpiEndDate.value), getPreviousDate({ days: 1 }, productPagesKpiEndDate.value)] },
        placement: 'left',
        onFocus: () => evolutionCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: 'Last 30 Days',
        value: () => { return [getPreviousDate({ days: 30 }, productPagesKpiEndDate.value), getPreviousDate({ days: 1 }, productPagesKpiEndDate.value)] },
        placement: 'left',
        onFocus: () => evolutionCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: 'Last Month',
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(productPagesKpiEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(productPagesKpiEndDate.value).setDate(1)))
            ]
        },
        placement: 'left',
        onFocus: () => evolutionCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]